/**
 * Subscription levels for feature gating. Must match backend RequiredPackage / plan codes.
 */
export type SubscriptionLevel = "Lite" | "Standard" | "Pro";

const LEVEL_ORDER: Record<string, number> = {
  Lite: 1,
  Standard: 2,
  Pro: 3,
  Basic: 2, // legacy plan code from DB; backend maps BASIC → Standard tier
};

/**
 * Returns true if the user's subscription level has access to features requiring `requiredLevel`.
 * If userLevel is null/undefined (e.g. SuperAdmin or loading), returns true (allow all).
 */
export function hasSubscriptionAccess(
  userLevel: string | null | undefined,
  requiredLevel: SubscriptionLevel
): boolean {
  if (userLevel == null || userLevel === "") return true;
  const userOrder = LEVEL_ORDER[userLevel] ?? 0;
  const requiredOrder = LEVEL_ORDER[requiredLevel] ?? 0;
  return userOrder >= requiredOrder;
}
